import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SEOHead from '@/components/feature/SEOHead';
import HeroBanner from './components/HeroBanner';
import CategoryNav from './components/CategoryNav';
import PopularComics from './components/PopularComics';
import LatestUpdates from './components/LatestUpdates';
import FAQSection from './components/FAQSection';

export default function Home() {
  return (
    <>
      <SEOHead
        title="韩漫免费阅读_漫画在线_无遮韩国漫画大全"
        description="韩国漫画网提供韩漫免费阅读和漫画在线服务，包含无遮韩国漫画大全，内容多样且操作简单，为您节省时间与精力。每日更新热门韩漫，支持多种类型分类浏览。"
        keywords="韩漫免费阅读,漫画在线,无遮韩国漫画大全,韩国漫画网,韩漫,韩国漫画"
        canonicalUrl="/"
        schemaData={[
          {
            '@context': 'https://schema.org',
            '@type': 'WebSite',
            name: '韩国漫画网',
            url: 'https://www.koreancomic.cn',
            description: '韩国漫画网提供韩漫免费阅读和漫画在线服务，包含无遮韩国漫画大全。',
            potentialAction: {
              '@type': 'SearchAction',
              target: 'https://www.koreancomic.cn/search?q={search_term_string}',
              'query-input': 'required name=search_term_string',
            },
          },
          {
            '@context': 'https://schema.org',
            '@type': 'Organization',
            name: '韩国漫画网',
            url: 'https://www.koreancomic.cn',
            description: '韩国漫画网提供韩漫免费阅读和漫画在线服务，包含无遮韩国漫画大全。',
            foundingDate: '2020',
            contactPoint: {
              '@type': 'ContactPoint',
              contactType: 'customer service',
              email: 'contact@koreancomic.cn',
            },
          },
          {
            '@context': 'https://schema.org',
            '@type': 'WebPage',
            name: '韩漫免费阅读_漫画在线_无遮韩国漫画大全-韩国漫画网',
            description: '韩国漫画网提供韩漫免费阅读和漫画在线服务，包含无遮韩国漫画大全。',
            breadcrumb: {
              '@type': 'BreadcrumbList',
              itemListElement: [
                { '@type': 'ListItem', position: 1, item: { '@id': 'https://www.koreancomic.cn', name: '首页' } },
              ],
            },
          },
          {
            '@context': 'https://schema.org',
            '@type': 'FAQPage',
            mainEntity: [
              {
                '@type': 'Question',
                name: '韩国漫画网是完全免费的吗？',
                acceptedAnswer: { '@type': 'Answer', text: '是的，韩国漫画网提供的所有韩漫内容均为免费阅读。我们致力于为广大漫画爱好者提供无门槛的优质韩国漫画阅读体验，无需注册会员即可畅享全部内容。' },
              },
              {
                '@type': 'Question',
                name: '网站更新频率是怎样的？',
                acceptedAnswer: { '@type': 'Answer', text: '我们每天都会同步更新最新的韩漫章节，确保读者可以第一时间阅读到最新的漫画内容。热门连载作品通常每日更新一话。' },
              },
              {
                '@type': 'Question',
                name: '如何找到我想看的漫画？',
                acceptedAnswer: { '@type': 'Answer', text: '我们提供了多种方式帮助您快速找到想看的漫画：您可以通过首页的"漫画分类"板块按类型浏览，也可以使用"热门推荐"发现大家都在看的作品。' },
              },
              {
                '@type': 'Question',
                name: '网站支持手机阅读吗？',
                acceptedAnswer: { '@type': 'Answer', text: '当然支持！韩国漫画网采用了响应式设计，完美适配手机、平板和电脑等各类设备。' },
              },
              {
                '@type': 'Question',
                name: '漫画的画质如何？',
                acceptedAnswer: { '@type': 'Answer', text: '我们采用高清图像传输技术，确保每一页漫画都清晰可见。所有韩漫内容均为原版高清画质。' },
              },
            ],
          },
        ]}
      />
      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main>
          <HeroBanner />
          <CategoryNav />
          <PopularComics />
          <LatestUpdates />
          <FAQSection />
        </main>
        <Footer />
      </div>
    </>
  );
}